import { createUseStyles } from 'react-jss';
import { ITheme } from '../../../components/theme';

type RuleNames =
  | 'title'
  | 'volunteers1'
  | 'volunteers2'
  | 'volunteers3'
  | 'paperBlock'
  | 'paper'
  | 'tableContainer'
  | 'volunteersBlock'
  | 'avatarBlock1'
  | 'avatarBlock2'
  | 'avatarBlock3'
  | 'avatar'
  | 'paragraph'
  | 'tableRow'
  | 'tableHead'
  | 'noticeBlock'
  | 'buttonBlock'
  | 'buttonEdit'
  | 'avatarList'
  | 'firstAvatarPosition'
  | 'secondAvatarPosition'
  | 'copyText';

const PREFIX = 'Volunteers';
export const useStyles = createUseStyles<RuleNames, unknown, ITheme>(
  (theme: ITheme) => (
    {
      tableRow: {
        cursor: 'pointer',
        '& *': {
          color: theme.darkGreen,
          fontFamily: theme.helveticaNeue,
        },
      },
      title: {
        color: theme.darkGreen,
        fontFamily: theme.caslonDoric,
        fontSize: 20,
        margin: '0 0 8px',
      },
      volunteers1: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 16,
        width: 230,
        marginBottom: 31,
      },
      volunteers2: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 16,
        width: 270,
        marginBottom: 31,
      },
      volunteers3: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 16,
        width: 310,
        marginBottom: 31,
      },
      tableHead: {
        '& *': {
          fontWeight: 900,
          color: '#2F4C32',
          fontFamily: theme.helveticaNeue,
        },
      },
      noticeBlock: {
        display: 'flex',
        justifyContent: 'space-between',
      },
      buttonBlock: {
        alignSelf: 'start',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      },
      buttonEdit: {
        background: theme.lightGreen,
        borderRadius: '4px',
        color: theme.darkGreen,
        fontSize: '14px',
        textTransform: 'uppercase',
        lineHeight: '24px',
        padding: '6px 16px',
        fontWeight: 600,
        cursor: 'pointer',
        '&:hover': {
          background: theme.hoverLightGreen,
        },
      },
      paperBlock: {
        '& .MuiPaper-root': {
          border: '1px solid rgba(224, 224, 224, 1)',
          borderRadius: '12px',
          boxShadow: 'none',
        },
        '& .MuiTableRow-root': {
          height: 64,
        },
        '& .MuiTableCell-root': {
          padding: 13,
        },
        '& .MuiTableContainer-root': {
          height: 265,
        },
        '& .MuiTablePagination-toolbar': {
          height: 48,
        },
        '& .MuiTableContainer-root::-webkit-scrollbar': {
          width: '0.2em',
          backgroundColor: '#F5F5F5',
        },
        '& .MuiTableContainer-root::-webkit-scrollbar-thumb': {
          backgroundColor: '#000000',
          borderRadius: '10px',
        },
        '& .MuiTableContainer-root::-webkit-scrollbar-thumb:hover': {
          backgroundColor: '#555555',
        },
        '& .MuiTableContainer-root::-webkit-scrollbar-corner': {
          backgroundColor: '#F5F5F5',
        },
      },
      paragraph: {
        color: 'rgba(0, 0, 0, 0.5)',
        fontSize: 14,
        margin: 0,
      },
      paper: {
        width: '100%',
        overflow: 'hidden',
      },
      tableContainer: {
        maxHeight: 570,
      },
      volunteersBlock: {
        width: '100%',
        '& .MuiSvgIcon-root': {
          color: '#6CA370',
        },
      },
      avatarBlock1: {
        display: 'flex',
        position: 'relative',
        width: '13%',
        height: 32,
      },
      avatarBlock2: {
        display: 'flex',
        position: 'relative',
        width: '25%',
        height: 32,
      },
      avatarBlock3: {
        display: 'flex',
        position: 'relative',
        width: '33%',
        height: 32,
      },
      avatar: {
        width: 30,
        height: 30,
        borderRadius: '50%',
        textAlign: 'center',
        marginTop: '6px',
        objectFit: 'cover',
      },
      avatarList: {
        width: 30,
        height: 30,
        borderRadius: '50%',
        textAlign: 'center',
        objectFit: 'cover',
      },
      firstAvatarPosition: {
        position: 'relative',
        right: '10px',
      },
      secondAvatarPosition: {
        position: 'relative',
        right: '20px',
      },
      copyText: {
        cursor: 'pointer',
        '&:hover': {
          color: 'rgba(0, 0, 0, 0.5)',
        },
      },
    }
  ),
  { name: PREFIX },
);
